export { default as Header } from 'reports/components/employees_assets/EmployeesAssetsReportHeader';
export { default as Table } from 'reports/components/employees_assets/EmployeesAssetsReportTable';
export { default as Filters } from 'reports/components/employees_assets/EmployeesAssetsReportFilters';



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/components/employees_assets/index.js